export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-image-441765c005f6a16985a41dadb7b3ca6c.svg";